var React = require('react');

function LightboxClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"#fff","fillRule":"evenodd"},[React.createElement("rect",{"transform":"translate(11.313708, 11.313708) rotate(-45.000000) translate(-11.313708, -11.313708) ","x":"10.3137085","y":"-3.6862915","width":"2","height":"30","key":0}),React.createElement("rect",{"transform":"translate(11.313708, 11.313708) rotate(-315.000000) translate(-11.313708, -11.313708) ","x":"10.3137085","y":"-3.6862915","width":"2","height":"30","key":1})]));
}

LightboxClose.defaultProps = {"width":"23px","height":"23px","viewBox":"0 0 23 23","version":"1.1"};

module.exports = LightboxClose;

LightboxClose.default = LightboxClose;
